/**
 * H5P Components i18n
 * Internal translations for H5P Editor and Player components
 */

export interface H5PTranslations {
  preview: string;
  previewUpdating: string;
  previewPlaceholder: string;
  fullscreen: string;
  exitFullscreen: string;
  refresh: string;
  refreshing: string;
  loading: string;
  loadError: string;
  invalidContentType: string;
  noContent: string;
}

const en: H5PTranslations = {
  preview: 'Preview',
  previewUpdating: '(updating...)',
  previewPlaceholder: 'Preview will appear here after content is loaded',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit',
  refresh: 'Refresh',
  refreshing: 'Refreshing...',
  loading: 'Loading H5P content...',
  loadError: 'Failed to load content',
  invalidContentType: 'This content does not contain H5P data. Use ACHEditor instead.',
  noContent: 'No content to display',
};

const vi: H5PTranslations = {
  preview: 'Xem trước',
  previewUpdating: '(đang cập nhật...)',
  previewPlaceholder: 'Nội dung xem trước sẽ hiển thị sau khi tải xong',
  fullscreen: 'Toàn màn hình',
  exitFullscreen: 'Thoát',
  refresh: 'Làm mới',
  refreshing: 'Đang làm mới...',
  loading: 'Đang tải nội dung H5P...',
  loadError: 'Không thể tải nội dung',
  invalidContentType: 'Nội dung này không phải H5P. Hãy sử dụng ACHEditor.',
  noContent: 'Không có nội dung để hiển thị',
};

const translations: Record<string, H5PTranslations> = {
  en,
  vi,
};

let currentLocale = 'en';

export function setLocale(locale: string): void {
  if (translations[locale]) {
    currentLocale = locale;
  }
}

export function getLocale(): string {
  return currentLocale;
}

export function t<K extends keyof H5PTranslations>(key: K): string {
  return translations[currentLocale]?.[key] || translations.en[key] || key;
}

export function useH5PTranslations(): H5PTranslations {
  return translations[currentLocale] || translations.en;
}

export default { t, setLocale, getLocale, useH5PTranslations };
